<div class="page">
  <div class="page__container">
    <h1 class="page__title h2" translate>page_not_found_title</h1>
    <h2 class="my-5"><a routerLink="/" translate>page_not_found_back_to_homepage</a></h2>
  </div>
</div>
